import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearProductItemListAction } from "../../Store/actions/apparelAction";
import './apparelMenu.scss';

// Phase 1: the horizontal top navigation was replaced by the AppShell sidebar
// (src/shared/app-shell.tsx). This component is kept as a headless shim so the
// original side effect below runs in exactly the same place it always did —
// clearing the in-progress bill's product list on every screen except Create
// Bill. It renders no UI. The `.scss` import is retained so the global antd
// menu-popup overrides it defines remain available to other legacy screens.
const ApparelMenu = (_props: any) => {
    const dispatch = useDispatch();
    const currentURL = window.location.pathname;

    useEffect(() => {
        if (currentURL != "/create/bill") {
            dispatch(clearProductItemListAction());
        }
    }, [currentURL]);

    return null;
}

export default ApparelMenu;
